module.exports = __webpack_public_path__ + "img/asus-tufa15.840cc6e6.png";